<template>
    <div class="Psychological_archives">
      <transit :users="UserID" />
      <div></div>
      <div>
        <el-descriptions>
          <el-descriptions-item label="学生ID">{{ Data.UserID }}</el-descriptions-item>
          <el-descriptions-item label="姓名">{{ Data.RealName }}</el-descriptions-item>
          <el-descriptions-item label="年级">{{ Data.EntryDate }}</el-descriptions-item>
          <el-descriptions-item label="培养单位：">{{ Data.DeptName }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ Data.Sex }}</el-descriptions-item>
          <el-descriptions-item label="出生日期">{{ Data.Birthday }}</el-descriptions-item>
          <el-descriptions-item label="集中教学院系">{{ Data.TeachDeptName }}</el-descriptions-item>
          <el-descriptions-item label="心理辅导员">{{ Data.InstructorName }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{ Data.IDCard }}</el-descriptions-item>
          <el-descriptions-item label="民族">{{ Data.Nation }}</el-descriptions-item>
        </el-descriptions>
        <div>
          <h2 style="margin-top: 20px;margin-left: 2%;">所有档案</h2>
          <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 20px;">
            <el-table-column prop="RecordName" label="提交人" width="180"></el-table-column>
            <el-table-column prop="ReportTime" label="生成时间" width="180"></el-table-column>
            <el-table-column prop="Type" label="档案类型"></el-table-column>
            <el-table-column prop="UrgentStatus" label="当前危机状态">
              <template slot-scope="scope">
                <span v-if="scope.row.AdjustBeforeStatus == '黄色预警'" style="color: #A68F52;">{{ scope.row.AdjustBeforeStatus }}</span>
                <span v-else-if="scope.row.AdjustBeforeStatus == '橙色预警'" style="color: rgb(252, 111, 68);">{{ scope.row.AdjustBeforeStatus }}</span>
                <span v-else-if="scope.row.AdjustBeforeStatus == '红色预警'" style="color: #FF0808;">{{ scope.row.AdjustBeforeStatus }}</span>
                <span v-else-if="scope.row.AdjustBeforeStatus == '蓝色预警'" style="color: rgba(0, 136, 255, 1);">{{ scope.row.AdjustBeforeStatus }}</span>
                <span v-else-if="scope.row.AdjustBeforeStatus == '绿色预警'" style="color: rgb(112 191 15);">{{ scope.row.AdjustBeforeStatus }}</span>
                <span v-else-if="scope.row.AdjustBeforeStatus == '--'">{{ scope.row.AdjustBeforeStatus }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="UrgentStatus" label="调整后危机状态">
              <template slot-scope="scope">
                <span v-if="scope.row.AdjustAfterStatus == '黄色预警'" style="color: #A68F52;">{{ scope.row.AdjustAfterStatus }}</span>
                <span v-else-if="scope.row.AdjustAfterStatus == '橙色预警'" style="color: rgb(252, 111, 68);">{{ scope.row.AdjustAfterStatus }}</span>
                <span v-else-if="scope.row.AdjustAfterStatus == '红色预警'" style="color: #FF0808;">{{ scope.row.AdjustAfterStatus }}</span>
                <span v-else-if="scope.row.AdjustAfterStatus == '蓝色预警'" style="color: rgba(0, 136, 255, 1);">{{ scope.row.AdjustAfterStatus }}</span>
                <span v-else-if="scope.row.AdjustAfterStatus == '绿色预警'" style="color: rgb(112 191 15);">{{ scope.row.AdjustAfterStatus }}</span>
                <span v-else-if="scope.row.AdjustAfterStatus == '--'">{{ scope.row.AdjustAfterStatus }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="AdjustCrisisGrade" label="干预编号"></el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span v-if="scope.row.Type == '谈话记录'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
                <span v-else-if="scope.row.Type == '心理测评'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.UserID,scope.row.KeyNo)">查看详情</span>
                <span v-else-if="scope.row.Type == '咨询上报'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="ViewRecords(scope.row)">查看详情</span>
                <span v-else-if="scope.row.Type == '自主上报' || scope.row.Type == '日常危机'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看详情</span>
                <span v-else-if="scope.row.Type == '多方会谈'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="$router.push('/Crisis/Multiparty?KeyNo='+scope.row.MTalk+'&num=1')">查看详情</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination style="margin-top:20px;text-align:right" @current-change="handleCurrentChange" :current-page.sync="PageIndex" :page-size="10"  layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>
        
      </div>
      <Crisiscases ref="childdetail"></Crisiscases>
    </div>
</template>

<script>
import Crisiscases from './../Consultant/Crisiscases.vue';
import transit from './transit'
  export default {
    data(){
      return {
        RoleID: '',
        UserID: '',
        PageIndex: 1,
        PageSize: 10,
        Count: 1,
        tableData: [],
        Data: [],
      }
    },
    components: {
      transit,
      Crisiscases
    },
    methods: {
      Crisis_evaluation_view(PublishID, UserID,KeyNo) {//查看访谈表
        this.$router.push({
          path: '/Crisis/Crisis_evaluation_view',
          query: { PublishID: PublishID, UserID: UserID , KeyNo : KeyNo},
        })
      },
      Crisis_lookprefabrication(KeyNo, reportStatus, userId) {//查看预制表
        this.$router.push({
          path: '/Crisis/Crisis_lookprefabrication',
          query: {KeyNo:KeyNo,reportStatus:reportStatus,userId:userId},
        })
      },
      Crisis_Memcon_view(TalkNo,KeyNo) {
        this.$router.push({
          path: '/Crisis/Crisis_Memcon_view',
          query: {TalkNo: TalkNo,KeyNo:KeyNo},
        });
      },
      ViewRecords(e){
        this.$refs.childdetail.CrisisreporDetail(e,-2);
      },
      handleCurrentChange(val) {//分页点击
        this.PageIndex = val;
        this.loading();
      },
      loading() {
        this.$Http_Post('DistressPrediction/StuAllFile', {UserID: this.UserID , PageIndex :this.PageIndex , PageSize :this.PageSize }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Count = Number(res.Counts);
          }
        });
      }
    },
    mounted() {
      this.RoleID = [this.$route.query.RoleID][0];
      this.UserID = [this.$route.query.UserID][0];
      this.$Http_Post('DistressPrediction/StuBasicFile', {UserID:this.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Data = res.Data;
        }
      });
        this.loading();
      },
    }
</script>

<style>
.Psychological_archives{width: 100%;height: 100%;background-color: #fff;}
.Psychological_archives .el-descriptions__body table td, .el-descriptions__body table th {padding-top: 12px;padding-left: 12px;}
.Psychological_archives .el-descriptions{padding-top:20px;width: 96%;margin:  auto;}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>